import { cn as e } from "../shared/utils.js";
import { mergeProps as t } from "@base-ui/react/merge-props";
import { useRender as n } from "@base-ui/react/use-render";
import { forwardRef as r } from "react";
//#region src/skeleton/skeleton.tsx
var i = r(({ className: r, render: i, ...a }, o) => {
	let s = {
		"aria-hidden": !0,
		className: e("skeleton-animation bg-bg-quaternary rounded-md block", r)
	};
	return n({
		defaultTagName: "span",
		props: t(s, a),
		ref: o,
		render: i
	});
});
i.displayName = "Skeleton";
//#endregion
export { i as Skeleton };
